import { ErrorCatcher } from '../../tools/error-catcher';
import { useAppContext } from '../../app-context-provider/app-context-provider';
import { getImageObject } from './schema';
import { ImageWordpress } from '../../types/shared';

type ContentType = {
    content: {
        post_title: string;
        list_description: string;
        permalink: string;
        featured_image: ImageWordpress;
    }
};

type ListingProps = {
    content: Array<ContentType>;
    postListingType: 'Blog' | 'itemListElement';
    archiveName?: string;
    postSingleType: 'BlogPosting' | 'ListItem';
    archiveUrl?: string;
    useHeadline?: boolean;
};

type postSchemaType = {
    '@type': string;
    name: string;
    image: ReturnType<typeof getImageObject> | undefined;
    description: string;
    url: string;
    headline?: string;
};

export const postSchema = (content: any, postSingleType: string, useHeadline: boolean) => {
    const { siteInfo } = useAppContext();

    const schema: postSchemaType = {
        '@type': postSingleType,
        'name': content?.post_title,
        'image': getImageObject(content?.featured_image),
        'description': content?.list_description,
        'url': siteInfo.baseurl + content?.permalink,
    };

    if (useHeadline && content?.post_title) {
        schema.headline = content?.post_title;
    }
};


const listSchemaContent = (props: ListingProps) => {
    const { postListingType, archiveName, postSingleType, archiveUrl, content, useHeadline } = props;
    const listPosts = content?.map((post: any) => postSchema(post.content, postSingleType,  useHeadline || false));

    const schema: any = {
        '@context': 'https://schema.org/',
        '@type': postListingType,
        [postSingleType]: listPosts
    };

    if (archiveName) {
        schema.name = archiveName;
    }

    if (archiveUrl) {
        schema.url = archiveUrl;
    }

    return JSON.stringify(schema);
};

export const PostListingSchema = (props: ListingProps) => {
    return (
        <ErrorCatcher componentName="Post listing Schema">
            <script type="application/ld+json">{listSchemaContent(props)}</script>
        </ErrorCatcher>
    );
};